/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleRoot extends models.BillingRuleGroup {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleRoot");
    }

    getFixupPrototypeFunction() { return BillingRuleRoot.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleRoot>): BillingRuleRoot {
        let obj = Object.assign(new BillingRuleRoot(), model);
        BillingRuleRoot.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleRoot>): BillingRuleRoot {
        if (!model) return null;
        return BillingRuleRoot.newInstance(<BillingRuleRoot> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleRoot) {
        if (!obj) return;

        models.BillingRuleRoot.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleRoot): boolean {
        if (models.BillingRuleGroup.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleRoot.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.source_metric_overrides) {
            for (let val of this.source_metric_overrides) {
                models.BillingMetricSourceOverride.fixupPrototype(val);
            }
        }
    }

    /**
     * Parent plan ID
     */
    parent_plan_id: string;

    /**
     * Describes the destination metrics of the billing plan.
     */
    destination_metric: string;

    /**
     * Describes the source metric of the billing plan.
     */
    source_metric: string;

    /**
     * List of source metric overrides by native details
     */
    source_metric_overrides: Array<models.BillingMetricSourceOverride>;

    /**
     * True if the rules contained by the group should match service account ancestors
     */
    match_service_account_ancestors: boolean = false;

}
